import React__default from 'react';
import { FormControlLabel, Radio, Typography } from '@mui/material';
import StyledRadioList, { classes } from './index.styled.js';

var RadioList = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, radioListItems = _a.radioListItems, handleChange = _a.handleChange, sx = _a.sx;
    var handleKeyDown = function (event) {
        if (event.key === "Enter" || event.key === " ") {
            handleChange(event.target.value);
        }
    };
    return (React__default.createElement(StyledRadioList, { "aria-label": label, name: name, value: value, onKeyDown: handleKeyDown, onMouseUp: function (e) {
            handleChange(e.target.value);
        }, sx: sx }, radioListItems.map(function (_a) {
        var id = _a.id, label = _a.label, title = _a.title;
        return (React__default.createElement(FormControlLabel, { key: id, control: React__default.createElement(Radio, { size: "small" }), value: id, label: React__default.createElement(Typography, { onClick: function () { return handleChange(id); }, variant: "caption", noWrap: true, display: "block", title: title || label, className: classes.label }, label), className: classes.formControlLabel }));
    })));
};

export { RadioList as default };
//# sourceMappingURL=index.js.map
